import React from "react";
import { CompanyForContactPreviewPanel } from "./CompanyForContactPreviewPanel";

interface ContactWorksAtPreviewPanelProps {
  worksAt: server.dto.CompanyWithWorkRelation[]
}

export const ContactWorksAtPreviewPanel = ({ worksAt }: ContactWorksAtPreviewPanelProps) => {
  if (worksAt.length === 0) {
    return null;
  }

  return <div className="flex-column gap">
    <div className="nav-text-regular">{RESX.GeneralLabels.WorksAt}</div>
    {worksAt.map(companyWithWorkRelation => <CompanyForContactPreviewPanel key={companyWithWorkRelation.company.companyId} company={companyWithWorkRelation} />)}
  </div>
}